/**
2  *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
3  *
4  * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
5  * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
6  * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
7  * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
8  * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
9  * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
10  * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
11  * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
12  * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
13  * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
14  * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
15  */

import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
declare var $: any;

@Component({
    selector: 'zsd-booleanfield',
    templateUrl: '../../view/customfields/booleanfield.component.html',
    styleUrls: ['../../view/customfields/customfields.component.scss']
})
export class BooleanFieldComponent implements OnInit {
    @Input() displayName = '';
    @Input() fieldType;
    @Input() description;
    @Input() dscEnable;
    @Input() required;
    @Input() clientVisible;
    @Input() fieldId;
    @Input() clientEditable;
    @Input() defaultValue;
    @Input() valueType;
    @Input('parentForm') public parentForm: FormGroup;
    @Input('fromQuickCall') public fromQuickCall: boolean;


    submissionValue;
    booleanFieldForm: FormGroup;

    constructor(public formBuilder: FormBuilder) { }



    ngOnInit() {
        // Setup for Reactive Form

        this.booleanFieldForm = this.formBuilder.group({
            data: this.formBuilder.control({ value: null, disabled: (this.clientEditable ? false : true) }),
        });

        this.submissionValue = this.defaultValue;
        if (this.defaultValue) {
            this.booleanFieldForm.get('data').setValue(this.submissionValue);
        }
        if (this.required === 1) {
            this.booleanFieldForm.get('data').setValidators([Validators.required]);
        }

        this.booleanFieldForm.updateValueAndValidity();
        if (this.parentForm) {
            this.parentForm.addControl(this.fieldId + '', this.booleanFieldForm);
        }
        this.parentForm.setControl(this.fieldId + '', this.booleanFieldForm);

        // Setup for description jquery

        if (this.dscEnable === 1) {
            $(document).ready(function () {
                $('[data-toggle=' + this.fieldId + ']').popover();
            }.bind(this));
        }

    }

}

